import { createStyles, makeStyles } from '@material-ui/core';
import theme from 'src/assets/theme';
const { colors } = theme;

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        fontFamily: ['Ubuntu', 'sans-serif'].join(',')
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
        fontFamily: ['Ubuntu', 'sans-serif'].join(',')
      },
      body: {
        backgroundColor: '#f4f6f8',
        height: '100%',
        width: '100%',
        fontFamily: ['Ubuntu', 'sans-serif'].join(',')
      },
      a: {
        textDecoration: 'none',
        color: colors.primaryColor
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }
  })
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
